import store from "../../redux/store";

export const reduxIncrementEventTrackerNbr = (actionType) => {

      if (actionType  && actionType !== ""){
        const setGameInfo = () => {
          return {
            type: actionType
            }
        }
        store.dispatch(setGameInfo());
      }
      const eventTrackerNbr = store.getState().eventTrackerNbr;
      return eventTrackerNbr;
      
}
             

export default reduxIncrementEventTrackerNbr;